module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/klarna-payment-card-e66b555ff012e622b5af85d740e59055.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/klarna-payment-card.svg
// module id = 3eXq
// module chunks = 24